import Stepper from 'src/app/components/Display/Stepper/Stepper.page'

import { BackButton, Content, ContentHeader } from 'src/app/components';

import { useState } from 'react';
import { PageTitle } from 'src/app/components/Layout/header/HeaderTitle';
import CampaignScreens from '../../../CampaignScreens';
import { SalesPromoFormProps } from './SalesPromoForm.types';
import { SalesPromoForm1 } from './SalesPromoForm1.page';
import { SalesPromoForm2 } from './SalesPromoForm2.page';
import { SalesPromoForm3 } from './SalesPromoForm3.page';
import { SalesPromoForm4 } from './SalesPromoForm4.page';
import { useSalesPromoForm } from './SalesPromoForm.hook';

export function SalesPromoForm(props: Readonly<SalesPromoFormProps>) {
    const state = useSalesPromoForm()
    const [preventExit, setPreventExit] = useState(false)
    const breadcrumbs = [
        {
            isActive: false,
            path: [CampaignScreens.LIST_SALES_PROMO.PATH].join(),
            title: "Sales Promo"
        },
        { isActive: false, path: '', title: '', isSeparator: true },
    ];

    return (
        <>
            <BackButton className={state.currentStep !== 1 ? 'hidden' : ''} useAlert={preventExit}>Back</BackButton>
            <Content className="min-h-0">
                <ContentHeader title={`${props.title} Sales Promo`} />
                <PageTitle description={props.title} breadcrumbs={breadcrumbs}>
                    Campaign
                </PageTitle>
                <Stepper classNames='py-4 border-b' steps={state.steps} currentStep={state.currentStep} />
                {state.currentStep === 1 && <SalesPromoForm1 id={state.currentId} save={state.saveStep1} saveDraft={state.saveAsDraft} doPreventExit={setPreventExit} />}
                {state.currentStep === 2 && <SalesPromoForm2 id={state.currentId} save={state.saveStep2} saveDraft={state.saveAsDraft} doPreventExit={setPreventExit} backward={state.backward} currentDetail={state.currentDetail} />}
                {state.currentStep === 3 && <SalesPromoForm3 id={state.currentId} save={state.saveStep3} saveDraft={state.saveAsDraft} doPreventExit={setPreventExit} backward={state.backward} currentDetail={state.currentDetail} />}
                {state.currentStep === 4 && <SalesPromoForm4 id={state.currentId} save={() => state.saveStep4(props.title!)} backward={state.backward} currentDetail={state.currentDetail} />}
            </Content>
        </>
    )
}
